import { adminJson } from "./adminHttp";

/* =========================================================
   Small helpers (STRICT + CONSISTENT) - mirrors adminSupportApi
   ========================================================= */

function enc(v) {
  return encodeURIComponent(String(v));
}



/**
 * Backend sometimes uses an envelope: { ok, message, ts, data }.
 * Keep compatibility.
 */


/**
 * Build query params:
 * - skips undefined/null/empty-string
 * - trims strings
 */






/* =========================================================
   DIRECTORY: USERS (backend: /admin/support/users/directory)
   ========================================================= */

export async function fetchDirectoryUsers({
  q,
  status,
  risk,
  page = 0,
  size = 25,
} = {}) {
  const params = buildParams({
    q: asOptionalQuery(q),
    status: asOptionalAll(status), // ENABLED | BLOCKED | blank
    risk: asOptionalAll(risk), // HIGH | blank
    page,
    size,
  });

  return unwrapApi(await adminJson(`/admin/support/users/directory?${params.toString()}`));
}

export async function fetchDirectoryUsersSummary() {
  return unwrapApi(await adminJson(`/admin/support/users/directory/summary`));
}

function safeStr(v) {
  return v === undefined || v === null ? "" : String(v);
}
function cleanStr(v) {
  const s = safeStr(v).trim();
  return s ? s : "";
}
function unwrapApi(x) {
  if (x && typeof x === "object" && "ok" in x && "data" in x) return x.data;
  return x;
}
function buildParams(obj = {}) {
  const params = new URLSearchParams();
  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    const s = String(v).trim();
    if (!s) return;
    params.set(k, s);
  });
  return params;
}
function asOptionalAll(v) {
  const s = cleanStr(v);
  if (!s) return undefined;
  if (s.toUpperCase() === "ALL") return undefined;
  return s;
}
function asOptionalQuery(v) {
  const s = cleanStr(v);
  return s ? s : undefined;
}

/* =========================================================
   DIRECTORY: VEHICLES (backend: /admin/support/vehicles/directory)
   ========================================================= */

export async function fetchDirectoryVehicles({
  q,
  status, // compliance status
  risk,   // ATTENTION
  owner,  // LINKED | UNLINKED
  vehicleType, // CAR | AUTO | E_RICKSHAW | VAN
  page = 0,
  size = 25,
} = {}) {
  const params = buildParams({
    q: asOptionalQuery(q),
    status: asOptionalAll(status),
    risk: asOptionalAll(risk),
    owner: asOptionalAll(owner),
    vehicleType: asOptionalAll(vehicleType),
    page,
    size,
  });

  return unwrapApi(await adminJson(`/admin/support/vehicles/directory?${params.toString()}`));
}

export async function fetchDirectoryVehiclesSummary() {
  return unwrapApi(await adminJson(`/admin/support/vehicles/directory/summary`));
}

export async function permanentlyDeleteDirectoryVehicle(regNo, payload = {}) {
  return unwrapApi(
    await adminJson(`/admin/support/vehicles/${enc(regNo)}`, {
      method: "DELETE",
      body: JSON.stringify(payload || {}),
    })
  );
}

/* =========================================================
   DIRECTORY: OWNERS (backend: /admin/support/owners/directory)
   ========================================================= */

export async function fetchDirectoryOwners({
  q,
  status, // payout account status
  risk,   // ATTENTION
  link,   // LINKED | UNLINKED
  page = 0,
  size = 25,
} = {}) {
  const params = buildParams({
    q: asOptionalQuery(q),
    status: asOptionalAll(status),
    risk: asOptionalAll(risk),
    link: asOptionalAll(link),
    page,
    size,
  });

  return unwrapApi(await adminJson(`/admin/support/owners/directory?${params.toString()}`));
}

export async function fetchDirectoryOwnersSummary() {
  return unwrapApi(await adminJson(`/admin/support/owners/directory/summary`));
}



/* --------------------- Drivers Directory --------------------- */

export async function fetchDirectoryDrivers({
  q = "",
  status = "",
  risk = "",
  link = "",
  page = 0,
  size = 25,
} = {}) {
  const params = buildParams({ q, status, risk, link, page, size });
  const res = await adminJson(`/admin/support/drivers/directory?${params.toString()}`);
  return unwrapApi(res);
}

export async function fetchDirectoryDriversSummary() {
  const res = await adminJson(`/admin/support/drivers/directory/summary`);
  return unwrapApi(res);
}
